<template>
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div class="system-diagram-modal">
      <div class="container">
        <div class="modal-header">
          <h2>ファイル名更新</h2>
          <button class="close-button" @click.self="$emit('close')">
            <div class="close-button__line close-button__line--first" @click.self="$emit('close')"></div>
            <div class="close-button__line close-button__line--second" @click.self="$emit('close')"></div>
          </button>
        </div>
        <div class="form">
          <div class="form-input">
            <label>ファイルの旧名称：</label>
            <input type="text" class="input-field" :value="item.name" readonly />
          </div>
          <div class="form-input">
            <label>ファイルの新名称：</label>
            <input type="text"  class="input-field"  v-model="fileName"  name="fileName"  data-vv-as="ファイルの新名称" v-validate="'required|max:77'"/>
            <div class="err_message"> {{ errors.first("fileName") }}</div>
          </div>
          <div class="submit_area">
            <input type="submit" class="submit" value="更新" @click="onChangeName" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "csv-output-change-name-dialog",
  data: function () {
    return {
      fileName: ''
    };
  },
  props: {
    item: Object
  },
  methods: {
    onChangeName: function() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$emit('updateFileName', this.fileName);
        }
      });
    }
  }
};
</script>
